import { Entity } from "../core/entity";
import { ChatMessage } from "./chat-message.model";
import * as u8a from "uint8arrays";
import { base64ToBytes } from "did-jwt";
import { AccountId } from "caip";
export class SignatureRequestPayload extends Entity {
    get id() {
        return this.dto.id;
    }
    get message() {
        const messageDto = JSON.parse(u8a.toString(base64ToBytes(this.dto.jws.payload)));
        return new ChatMessage({ ...messageDto, ...this.dto });
    }
    get signers() {
        return this.dto.cacao.map((c) => new AccountId(AccountId.parse(c.p.iss.replace("did:pkh:", ""))));
    }
}
